import { useForm } from '@mantine/form';
import { Button, Flex, TextInput } from '@mantine/core';
import { parseYoutubeVideoId, youtubeWatchUrl } from '@4each/common';

interface YoutubeUrlFormProps {
  onAdd: (url: string) => Promise<void>;
}

export default function YoutubeUrlForm({ onAdd }: YoutubeUrlFormProps) {
  const form = useForm({
    initialValues: { url: '' },
    validate: {
      url: (value) => (parseYoutubeVideoId(value) ? null : 'Enter a YouTube video link'),
    },
  });

  async function handleSubmit({ url }: { url: string }) {
    const videoId = parseYoutubeVideoId(url);
    if (!videoId) return;
    await onAdd(youtubeWatchUrl(videoId));
    form.reset();
  }

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Flex gap="sm" align="flex-start">
        <TextInput flex={1} placeholder="https://www.youtube.com/watch?v=…" {...form.getInputProps('url')} />
        <Button type="submit" variant="light">Add video</Button>
      </Flex>
    </form>
  );
}
